import React from 'react'
import UserEditMain from '../../components/editviews/user/Main'

function UserSettings() {
    return (
        <>
            <UserEditMain />
        </>
    )
}

export default UserSettings
